import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: "primary" | "secondary" | "outlined";
  fullWidth?: boolean;
  className?: string;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = "primary",
  fullWidth = false,
  className = "",
  ...props
}) => {
  const getButtonClass = () => {
    switch (variant) {
      case "primary":
        return "buttonMain";
      case "secondary":
        return "buttonSecondary";
      case "outlined":
        return "buttonSecondaryOutlined";
      default:
        return "buttonMain";
    }
  };

  const buttonStyles = {
    width: fullWidth ? "100%" : "auto",
  };

  return (
    <button
      className={`${getButtonClass()} ${className}`}
      style={buttonStyles}
      {...props}
    >
      {children}
    </button>
  );
};
